import { RequestPasswordResetCtrl } from '../controllers/RequestPasswordResetCtrl';
import { Module } from '../Module';

Module.instance().directive('tbRequestPasswordReset',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'requestPasswordReset.html',
      scope: {},
      controller: RequestPasswordResetCtrl
    };
  }
);
